import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import { useCheckPermissions, hasPermission, ROUTER_PATHS, sizeTab, a11yProps, EstadoCuadreENUM } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableCuadreInventario from "../../shared/componente/table-cuadre-inventario/TableCuadreInventario";

export default function CuadreInventarioPage() {

  useCheckPermissions(PermissionsEnum.api_view_ubicacionproducto);

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"Cuadre Inventario"}
      py={2}
      enableRedirect={hasPermission(PermissionsEnum.api_add_ubicacionproducto)}
      urlRedirect={hasPermission(PermissionsEnum.api_add_ubicacionproducto) ? ROUTER_PATHS.inventario.cuadreInventarioCrearNav : undefined}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Borrador'} {...a11yProps(0)} />
          <Tab label={'Finalizadas'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableCuadreInventario
          estado_cuadre={`${EstadoCuadreENUM.BORRADOR},${EstadoCuadreENUM.REVERSAR}`}
          actionEdit={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableCuadreInventario
          estado_cuadre={EstadoCuadreENUM.FINALIZADO}
          actionEdit={false}
        />
      </CustomTabPanel>
    </SingleTableBoxScene >
  );

}